import React from 'react';
import { DayPickerProps } from 'react-day-picker';

import { ILocationSearchAutocompleteListOption } from '@/hooks/useLocationSearchAutocompleteOptions';
import { IHeaderSearchFilterDates, IHeaderSearchFilterGuests } from '@/redux/modules/globalHeader';

import DesktopNavbarSearch from './DesktopNavbarSearch/DesktopNavbarSearch';
import MobileNavbarSearch from './MobileNavbarSearch/MobileNavbarSearch';

interface INavbarSearchProps {
  onSubmit?: () => void;
  handleRecentSearchNavigation?: (url: string) => void;
  location?: { lat: number; lng: number };
  address?: string;
  guests?: IHeaderSearchFilterGuests;
  dates?: IHeaderSearchFilterDates;
  recentSearches?: ILocationSearchAutocompleteListOption[];
  maxRecentSearches: number;
  loading?: boolean;
  isHomePage?: boolean;
  onChangeAddress?: (address?: string, addressOption?: any) => void;
  onChangeDates: (address?: IHeaderSearchFilterDates) => void;
  onChangeGuests?: (guests?: IHeaderSearchFilterGuests) => void;
  onConfirmAddress?: (address?: string) => void;
  onConfirmDates?: (dates?: IHeaderSearchFilterDates) => void;
  onConfirmGuests?: (guests: IHeaderSearchFilterGuests) => void;
  className?: string;
  onClose?: () => void;
  onOpen?: () => void;
  popularDestinations?: ILocationSearchAutocompleteListOption[];
  alertStatus?: boolean;
  isPromoSearch?: boolean;
  isGuestOccupancyAvailable?: boolean;
  isSERP?: boolean;
  scrollToSearchFilter?: () => void;
  variant?: 'minimal' | 'enhanced';
  disabledDays?: DayPickerProps['disabled'];
  isCampground?: boolean;
  // Only applies to the desktop search bar — has no effect on MobileNavbarSearch.
  canShrink?: boolean;
  redesigned?: boolean;
}

const NavbarSearch: React.FC<INavbarSearchProps> = ({
  onSubmit,
  location,
  address,
  dates,
  guests,
  recentSearches = [],
  maxRecentSearches,
  loading = false,
  onChangeAddress,
  onChangeDates,
  onChangeGuests,
  onConfirmAddress,
  onConfirmDates,
  onConfirmGuests,
  className,
  onClose,
  onOpen,
  popularDestinations,
  alertStatus,
  handleRecentSearchNavigation,
  isPromoSearch,
  isGuestOccupancyAvailable,
  isSERP,
  scrollToSearchFilter,
  variant,
  disabledDays = [],
  isCampground,
  canShrink,
  redesigned,
}) => {
  return (
    <>
      <div
        className={`hidden md:block ${canShrink ? 'grow min-w-0 max-w-[580px]' : ''} ${className || ''}`}>
        <DesktopNavbarSearch
          location={location}
          address={address}
          dates={dates}
          guests={guests}
          recentSearches={recentSearches}
          maxRecentSearches={maxRecentSearches}
          onSubmit={onSubmit}
          loading={loading}
          onChangeAddress={onChangeAddress}
          onChangeDates={onChangeDates}
          onChangeGuests={onChangeGuests}
          onConfirmAddress={onConfirmAddress}
          onConfirmDates={onConfirmDates}
          onConfirmGuests={onConfirmGuests}
          popularDestinations={popularDestinations}
          alertStatus={alertStatus}
          handleRecentSearchNavigation={handleRecentSearchNavigation}
          isPromoSearch={isPromoSearch}
          variant={variant}
          isGuestOccupancyAvailable={isGuestOccupancyAvailable}
          isSERP={isSERP}
          scrollToSearchFilter={scrollToSearchFilter}
          disabledDays={disabledDays}
          isCampground={isCampground}
          canShrink={canShrink}
          redesigned={redesigned}
        />
      </div>
      <div className={`w-full md:hidden grid grid-flow-col auto-cols-fr ${className || ''}`}>
        <MobileNavbarSearch
          location={location}
          address={address}
          dates={dates}
          guests={guests}
          recentSearches={recentSearches}
          maxRecentSearches={maxRecentSearches}
          onChangeAddress={onChangeAddress}
          onChangeDates={onChangeDates}
          onChangeGuests={onChangeGuests}
          onClose={onClose}
          onOpen={onOpen}
          loading={loading}
          onSubmit={onSubmit}
          popularDestinations={popularDestinations}
          handleRecentSearchNavigation={handleRecentSearchNavigation}
          variant={variant}
          isGuestOccupancyAvailable={isGuestOccupancyAvailable}
          scrollToSearchFilter={scrollToSearchFilter}
          disabledDays={disabledDays}
          isSERP={isSERP}
          redesigned={redesigned}
        />
      </div>
    </>
  );
};

export default NavbarSearch;
